// Les TODO du code de départ disent souvent ce que la correction exigera (le texte d'un message, un
// nom imposé). L'étudiant les efface en écrivant : on les garde visibles à côté des consignes.
const TODO_LINE = /^\s*(?:\/\/|#)\s*TODO\b\s*(?:\d+\s*)?[:.)-]?\s*(.*)$/i;
// Ligne de commentaire seule : un TODO long continue souvent sur les lignes suivantes.
const COMMENT_LINE = /^\s*(?:\/\/|#)\s?(.*)$/;

export function extractStarterTodos(startingCode: string | undefined): string[] {
  if (!startingCode) return [];
  const todos: string[] = [];
  let current: string | null = null;
  const flush = () => {
    if (current) todos.push(current);
    current = null;
  };
  for (const line of startingCode.split('\n')) {
    const todo = TODO_LINE.exec(line);
    if (todo) {
      flush();
      current = todo[1].trim();
      continue;
    }
    const comment: RegExpExecArray | null = current !== null ? COMMENT_LINE.exec(line) : null;
    if (comment && comment[1].trim()) {
      current = `${current} ${comment[1].trim()}`.trim();
    } else {
      flush();
    }
  }
  flush();
  return todos;
}
